import {Message, SendMessagePayload} from '../hooks/useMessages'

const getStorageKey = (userId: string) => `msg_outbox_${userId}`;

export const messageStorage = {
    getFailedMessages: (userId: string, connectionId: string): Message[] => {
      try {
        const raw = localStorage.getItem(getStorageKey(userId));
        if (!raw) return [];
        const allMessages: Message[] = JSON.parse(raw);
        // Only return messages for the active chat window
        return allMessages.filter(m => m.connectionId === connectionId);
      } catch (e) {
        return [];
      }
    },

    addOrUpdateMessage: (userId: string, message: Message) => {
        const key = getStorageKey(userId);
        const raw = localStorage.getItem(key);
        let allMessages: Message[] = raw ? JSON.parse(raw) : [];
    
        const index = allMessages.findIndex(m => m.id === message.id);
        if (index > -1) {
          allMessages[index] = message; // Update existing (e.g. changing status to failed)
        } else {
          allMessages.push(message); // Add new
        }
    
        localStorage.setItem(key, JSON.stringify(allMessages));
      },

    removeMessage: (userId: string, messageId: string) => {
        const key = getStorageKey(userId);
        const raw = localStorage.getItem(key);
        if (!raw) return;
        
        let allMessages: Message[] = JSON.parse(raw);
        allMessages = allMessages.filter(m => m.id !== messageId);
        
        localStorage.setItem(key, JSON.stringify(allMessages));
    }

}